<template>
  <div class="item-gallery__content__list__item-container" ref="root">
    <router-link
      :to="{ name: 'details', params: { imageId: image.id } }"
      class="item-gallery__content__list__item"
    >
      <img
        v-if="titlePicture"
        :src="titlePicture?.srcMd"
        alt="item image"
        ref="image"
        class="item-gallery__content__list__item__img"
      />
      <p class="item-gallery__content__list__item__badge" v-if="periodLabel">
        <span
          class="item-gallery__content__list__item__badge__year"
          v-html="periodLabel"
        ></span>
      </p>
    </router-link>
  </div>
</template>
<script>
import mosaicTile from "@/mixins/mosaicTile";
import getPictureUrl from "@/helpers/getPictureUrl";
import { IMAGE_SRC_TYPES } from "@/config/image";
export default {
  name: "ItemGalleryListItem",
  mixins: [mosaicTile],
  props: {
    image: { type: Object, required: true },
    isFloatTop: { type: Boolean, default: false },
  },
  computed: {
    titlePicture() {
      const pic = this.image.titlePicture || this.image;
      if (pic.srcType === IMAGE_SRC_TYPES.YOUTUBE) {
        const thumb = getPictureUrl(pic.src, pic.srcNumber, pic.srcType, "md");
        return { ...pic, srcMd: thumb };
      }
      if (pic?.src?.startsWith("data:image")) {
        return { ...pic, srcMd: pic.src };
      }
      return pic;
    },
   periodLabel() {
  const epoch = this.image?.epoch;
  if (!epoch) return '';

  const { from, to } = epoch;

  if (from != null && to != null) return `${from} – ${to}`;
  if (from != null) return `${from} –`;
  if (to != null) return `– ${to}`;

  return '';
},

  },
  // mounted() {
  //   if (this.isFloatTop) {
  //       this.mountMosaic();
  //   }
  // },
  watch: {
    image: {
      deep: true,
      handler(newVal) {
        if (newVal?.src?.startsWith("data:image")) {
          if (newVal.titlePicture) {
            newVal.titlePicture.srcMd = newVal.src;
            newVal.titlePicture.src = newVal.src;
          }
        }
      },
    },
  },
};
</script>






<style scoped>
.item-gallery__content__list__item__pdf-label {
  position: absolute;
  bottom: 6px;
  right: 6px;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
}
</style>


<style lang="scss">
.item-gallery__content__list__item-container {
  grid-row-end: span 20;
  padding-bottom: 30px;
}
.item-gallery__content__list__item {
  position: relative;
  background-image: url('~@/assets/images/image-fallback.png');
  background-position: center center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  overflow: hidden;

  &__img {
    min-width: 100%;
    min-height: 100%;
    object-fit: cover;
    transition: box-shadow .3s;
  }

  &__badge {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    width: 100%;
    height: 44px;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
    background-color: rgba(0, 0, 0, 0.394524);

    &__year {
      font-size: 1.5em;
      font-weight: 700;
      line-height: 1rem;
      color: #FFFFFF;
      text-align: right;
    }

  }

  &:hover &__img {
    box-shadow: 0 2px 6px $app-box-shadow-color;
  }

}

</style>
